import { __require as X } from "./utils.js";
var A, y;
function V() {
  if (y) return A;
  y = 1;
  var s = Object.defineProperty, f = Object.getOwnPropertyDescriptor, b = Object.getOwnPropertyNames, D = Object.prototype.hasOwnProperty, h = (t, e) => {
    for (var o in e)
      s(t, o, { get: e[o], enumerable: !0 });
  }, l = (t, e, o, N) => {
    if (e && typeof e == "object" || typeof e == "function")
      for (let _ of b(e))
        !D.call(t, _) && _ !== o && s(t, _, { get: () => e[_], enumerable: !(N = f(e, _)) || N.enumerable });
    return t;
  }, g = (t) => l(s({}, "__esModule", { value: !0 }), t), T = {};
  h(T, {
    AUDIO_EXTENSIONS: () => a,
    DASH_EXTENSIONS: () => v,
    FLV_EXTENSIONS: () => S,
    HLS_EXTENSIONS: () => i,
    MATCH_URL_DAILYMOTION: () => E,
    MATCH_URL_FACEBOOK: () => L,
    MATCH_URL_FACEBOOK_WATCH: () => p,
    MATCH_URL_KALTURA: () => d,
    MATCH_URL_MIXCLOUD: () => I,
    MATCH_URL_MUX: () => C,
    MATCH_URL_SOUNDCLOUD: () => O,
    MATCH_URL_STREAMABLE: () => H,
    MATCH_URL_TWITCH_CHANNEL: () => w,
    MATCH_URL_TWITCH_VIDEO: () => u,
    MATCH_URL_VIDYARD: () => R,
    MATCH_URL_VIMEO: () => U,
    MATCH_URL_WISTIA: () => M,
    MATCH_URL_YOUTUBE: () => r,
    VIDEO_EXTENSIONS: () => c,
    canPlay: () => P
  }), A = g(T);
  var m = /* @__PURE__ */ X();
  const r = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//, O = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/, U = /vimeo\.com\/(?!progressive_redirect).+/, C = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/, L = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/, p = /^https?:\/\/fb\.watch\/.+$/, H = /streamable\.com\/([a-z0-9]+)$/, M = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/, u = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/, w = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/, E = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/, I = /mixcloud\.com\/([^/]+\/[^/]+)/, R = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/, d = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/, a = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i, c = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, i = /\.(m3u8)($|\?)/i, v = /\.(mpd)($|\?)/i, S = /\.(flv)($|\?)/i, n = (t) => {
    if (t instanceof Array) {
      for (const e of t)
        if (typeof e == "string" && n(e) || n(e.src))
          return !0;
      return !1;
    }
    return (0, m.isMediaStream)(t) || (0, m.isBlobUrl)(t) ? !0 : a.test(t) || c.test(t) || i.test(t) || v.test(t) || S.test(t);
  }, P = {
    youtube: (t) => t instanceof Array ? t.every((e) => r.test(e)) : r.test(t),
    soundcloud: (t) => O.test(t) && !a.test(t),
    vimeo: (t) => U.test(t) && !c.test(t) && !i.test(t),
    mux: (t) => C.test(t),
    facebook: (t) => L.test(t) || p.test(t),
    streamable: (t) => H.test(t),
    wistia: (t) => M.test(t),
    twitch: (t) => u.test(t) || w.test(t),
    dailymotion: (t) => E.test(t),
    mixcloud: (t) => I.test(t),
    vidyard: (t) => R.test(t),
    kaltura: (t) => d.test(t),
    file: n
  };
  return A;
}
export {
  V as __require
};
